module.exports = __webpack_public_path__ + "img/titleForLogoSlider.be613ec.png";